import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function Navbar() {
  const {
    lang,
    setLang,
    t
  } = useLanguage();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const navLinks = [{
    label: t.nav_portfolio,
    href: '#portafolio'
  }, {
    label: t.nav_services,
    href: '#servicios'
  }, {
    label: t.nav_philosophy,
    href: '#filosofia'
  }, {
    label: t.nav_consult,
    href: '#consulta'
  }];
  return <header className={`sticky top-0 z-50 backdrop-blur-md bg-black/60 transition-all duration-300 ${scrolled ? 'border-b border-white/[0.08]' : 'border-b border-transparent'}`} data-id="element-152" data-mp="9me4yzwesgzh">
      <div className="container mx-auto px-4 md:px-6" data-id="element-153" data-mp="1l1ubjpebzskc">
        <div className="flex items-center justify-between h-16 md:h-20" data-id="element-154" data-mp="9noaec20we55">
          {/* Left: badge + name */}
          <a href="#top" className="flex items-center gap-3 min-w-0" data-id="element-155" data-mp="elzjgkkhukmb">
            <span className="flex items-center justify-center w-9 h-9 md:w-10 md:h-10 border-2 border-white bg-[#08080e] text-white font-heading font-bold text-sm shrink-0" data-id="element-156" data-mp="jmdvset4ogq5">
              KG
            </span>
            <span className="flex flex-col leading-tight min-w-0" data-id="element-157" data-mp="3n4f6qwtw67kj">
              <span className="font-heading font-bold text-white text-sm md:text-base truncate" data-id="element-158" data-mp="3s279klw2re3i">
                Kinetic Growth Studio
              </span>
              <span className="hidden sm:block text-[10px] uppercase tracking-[0.15em] text-white/40 truncate" data-id="element-159" data-mp="uus05ra4yn2">
                {t.nav_sub}
              </span>
            </span>
          </a>

          {/* Center nav links */}
          <nav className="hidden lg:flex items-center gap-8" data-id="element-160" data-mp="39bzcoliyxjvr">
            {navLinks.map(link => <a key={link.href} href={link.href} className="text-xs uppercase tracking-[0.15em] text-white/70 hover:text-white transition-colors" data-id="element-161" data-mp="31b9sibyngrzv">
                {link.label}
              </a>)}
          </nav>

          {/* Right: lang toggle + CTA */}
          <div className="hidden md:flex items-center gap-4" data-id="element-162" data-mp="361q7w1m16nov">
            <div className="flex gap-1 items-center text-xs" aria-label={t.nav_lang_label} data-id="element-163" data-mp="2icfej570fvkr">
              <button onClick={() => setLang('EN')} className={`transition-colors ${lang === 'EN' ? 'text-white font-bold' : 'text-white/40 hover:text-white/70'}`} data-id="element-164" data-mp="2de45uxsgbr44">
                EN
              </button>
              <span className="text-white/20" data-id="element-165" data-mp="7junewfswdaz">|</span>
              <button onClick={() => setLang('ES')} className={`transition-colors ${lang === 'ES' ? 'text-white font-bold' : 'text-white/40 hover:text-white/70'}`} data-id="element-166" data-mp="7mgw4zefgyus">
                ES
              </button>
            </div>
            <a href="#consulta" className="bg-kinetic-yellow text-black font-bold text-xs md:text-sm rounded-md px-5 py-2 hover:brightness-110 transition-all duration-200" data-id="element-167" data-mp="f1sme70cw5zy">
              {t.nav_cta}
            </a>
          </div>

          {/* Mobile menu toggle */}
          <button className="lg:hidden text-white p-2 -mr-2" onClick={() => setMenuOpen(!menuOpen)} aria-label="Menu" data-id="element-168" data-mp="sxml5x7f1ezc">
            {menuOpen ? <X className="w-6 h-6" data-id="element-169" data-mp="k2q30f5pwrzc" /> : <Menu className="w-6 h-6" data-id="element-170" data-mp="o4jxg5pbkzr2" />}
          </button>
        </div>

        {/* Mobile menu */}
        {menuOpen && <div className="lg:hidden pb-6 flex flex-col gap-4 border-t border-white/10 pt-4" data-id="element-171" data-mp="1btw3iwpcorp5">
            {navLinks.map(link => <a key={link.href} href={link.href} onClick={() => setMenuOpen(false)} className="text-xs uppercase tracking-[0.15em] text-white/70 hover:text-white transition-colors" data-id="element-172" data-mp="1gmfl04r5s6z8">
                {link.label}
              </a>)}
            <div className="flex items-center gap-4 pt-2" data-id="element-173" data-mp="3f5kl2cahemhj">
              <div className="flex gap-1 items-center text-xs" data-id="element-174" data-mp="3b3h6hesin1s1">
                <button onClick={() => setLang('EN')} className={lang === 'EN' ? 'text-white font-bold' : 'text-white/40'} data-id="element-175" data-mp="bnk96m1t1wyn">
                  EN
                </button>
                <span className="text-white/20" data-id="element-176" data-mp="1w64lzuzy6yn">|</span>
                <button onClick={() => setLang('ES')} className={lang === 'ES' ? 'text-white font-bold' : 'text-white/40'} data-id="element-177" data-mp="3u1083xcn9i4f">
                  ES
                </button>
              </div>
              <a href="#consulta" onClick={() => setMenuOpen(false)} className="bg-kinetic-yellow text-black font-bold text-xs rounded-md px-5 py-2" data-id="element-178" data-mp="plqy3cos0mm6">
                {t.nav_cta}
              </a>
            </div>
          </div>}
      </div>
    </header>;
}